// src/pages/LoginPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/AuthContext';
import { useSubdomain } from '../contexts/SubdomainContext';
import { signInWithGoogle } from '../services/authService';
import LandingHeader from '../components/LandingHeader';
import LandingFooter from '../components/LandingFooter';
import '../styles/pages/LoginPage.scss'; // スタイルシートを更新します

const LoginPage = () => {
    const { currentUser, accountId, loading } = useAuth();
    const { hasSubdomain, loading: subdomainLoading } = useSubdomain();
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('');

    useEffect(() => {
        // locationのstateからメッセージを取得
        if (location.state?.message) {
            setMessage(location.state.message);
        }
    }, [location]);

    useEffect(() => {
        if (!loading && !subdomainLoading && currentUser && accountId) {
            // サブドメインが登録されていない場合はサブドメイン設定ページへ
            if (!hasSubdomain) {
                navigate(`/subdomain-setup/${accountId}`, { replace: true });
                return;
            }

            // サブドメインが登録済みの場合は元のページまたはダッシュボードへ
            const destination = location.state?.from || `/dashboard/${accountId}`;
            navigate(destination, { replace: true });
        }
    }, [currentUser, accountId, loading, subdomainLoading, hasSubdomain, navigate, location.state]);

    const handleGoogleLogin = async () => {
        try { // try-catchを追加してエラーハンドリングを強化
            const user = await signInWithGoogle();
            if (user) {

            }
        } catch (error) {
            console.error('Googleログインに失敗しました:', error);
            setMessage('ログインに失敗しました。再度お試しください。');
        }
    };

    return (
        <>
            <Helmet>
                <title>ログイン - Suisui</title>
                <meta name="description" content="Suisuiへのログインページです。Googleアカウントでログインしてウェブサイト管理を始めましょう。" />
            </Helmet>

            <div className="login-page">
                {/* ヘッダー */}
                <LandingHeader showNavButton={false} />

                {/* メインコンテンツ */}
                <div className="login-main">
                    <div className="container">
                        <div className="login-box">
                            {/* 管理画面のタイトルに合わせた見出しに変更 */}
                            <h1 className="login-title">Suisui</h1>
                            <p className="login-subtitle">ウェブサイト管理システム</p>
                            {message && (
                                <div className="login-message">
                                    {message}
                                </div>
                            )}
                            {/* ローディング中はボタンを無効化し、テキストも変更 */}
                            <button
                                className="login-button"
                                onClick={handleGoogleLogin}
                                disabled={loading}
                            >
                                <img
                                    src="https://www.google.com/favicon.ico"
                                    alt="Google"
                                    className="google-icon"
                                />
                                <span>Googleでログイン</span>
                            </button>
                            {/* Googleアイコンは削除またはCSSで非表示にします */}
                        </div>
                    </div>
                </div>

                {/* フッター */}
                <LandingFooter />
            </div>
        </>
    );
};

export default LoginPage;